//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadImg } from "@/api/uploadImg";
import LandMap from "@/components/LandMap";
import { mapActions, mapState } from "vuex";
export default {
  name: "OrderLand",
  data() {
    return {
      landList: [], // 所有的地块
      trajectoryList: [], // 所有的轨迹块
      workNum: "",
      workTypeId: "",
      mapTopInfoOptions: {
        data: [
          {
            id: 2,
            name: "待审核",
            colour: "#985523",
          },
          {
            id: 3,
            name: "合格",
            colour: "#52c41a",
          },
          {
            id: 4,
            name: "不合格",
            colour: "#e29e00",
          },
        ],
      },
      dialogVisible: false,
      ruleForm: {
        workTypeLandId: "",
        workTypeId: "",
        auditTime: this.getDateNow(),
        auditUserId: "",
        auditResult: "",
        remark: "",
      },
      rules: {
        auditTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        auditUserId: [
          { required: true, message: "请选择审核人员", trigger: "change" },
        ],
        auditResult: [
          { required: true, message: "请选择审核结果", trigger: "change" },
        ],
        remark: [
          { required: true, message: "请输入审核备注", trigger: "blur" },
        ],
        workAuditImg: [
          { required: true, message: "请上传照片", trigger: "change" },
        ],
      },
      pickerOptions: this.setPickerOptions(),
      workAuditImg: [], // 审核照片
      fileWorkAuditImgList: [], // 审核照片
      previewImgUrl: "",
      previeImgVisible: false,
    };
  },
  props: {
    orderId: {
      type: String,
    },
    fromType: {
      type: String,
    },
  },
  components: {
    LandMap,
  },
  computed: {
    ...mapState("map", {
      showTrajectory: (state) => state.showTrajectory,
    }),
  },
  watch: {
    showTrajectory(n) {
      if (n) {
        if (this.orderId && this.showTrajectory) {
          let params = { workTypeId: this.orderId };
          this.getOrderTrajectory(params);
        }
      }
    },
  },
  created() {
    this.getOrderLandList({ workTypeId: this.orderId });
  },
  methods: {
    ...mapActions("map", ["changeShowTrajectory"]),
    /**
     * @descripttion: 设置选择日期不能大于当前
     * @Author: juanjuanhui
     * @Date: 2021-12-14 21:02:01
     */
    setPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
      };
    },
    /**
     * @descripttion: 获取当前日期
     * @Author: juanjuanhui
     * @Date: 2022-01-14 15:12:37
     */
    getDateNow() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var date = now.getDate();
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getOrderLandList(params) {
      this.$http.cooperative.getWorkTypeLandList(params).then((res) => {
        this.landList = res.data;
      });
    },
    /**
     * @descripttion: 获取轨迹块
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:39:56
     */
    getOrderTrajectory(params) {
      this.$http.cooperative.getWorkTypeTrajectory(params).then((res) => {
        this.trajectoryList = res.data;
      });
    },
    /**
     * @descripttion: 添加作业质量审核
     * @Author: juanjuanhui
     * @Date: 2022-01-14 15:23:39
     */
    handleAddWorkAudit(curPolygonVal) {
      this.ruleForm.workTypeLandId = curPolygonVal.workLandId;
      this.ruleForm.workTypeId = curPolygonVal.workTypeId;
      this.dialogVisible = true;
    },
    /**
     * @descripttion: 获取提交参数
     * @Author: juanjuanhui
     * @Date: 2021-11-25 11:37:22
     * @param {*}
     */
    getParams() {
      let workAuditFileDtos = [];
      this.workAuditImg.forEach((item) => {
        workAuditFileDtos.push({
          picPath: item.url,
          fileName: item.name,
        });
      });
      let params = {
        ...this.ruleForm,
        workAuditFileDtos,
      };
      return params;
    },
    /**
     * @descripttion: 保存作业质量审核信息
     * @Author: juanjuanhui
     * @Date: 2022-01-14 15:24:30
     * @param {*} formName
     */
    handleSaveAddWorkAudit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.getParams();
          this.$http.village.addWorkAudit(params).then((res) => {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.$router.go(-1);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * @descripttion: 自定义上传图片
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:22:49
     * @param {*} content
     */
    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
        })
        .catch((err) => {
          content.onError(err);
          this.$message.error("服务器异常，请重新上传");
        });
    },
    /**
     * @descripttion: 上传图片成功
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:03
     * @param {*} file
     * @param {*} type
     * @return {*}
     */
    handleImgSuccess(file, type) {
      if (file.status != 111111) {
        this.$message.error(file.message);
        return;
      }
      switch (type) {
        case "workAuditImg":
          this[type].push({
            thumb: file.thumb,
            url: file.url,
          });
          break;
      }
    },
    /**
     * @descripttion: 删除图片
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:13
     * @param {*}
     * @return {*}
     */
    handleRemoveImg(file, type) {
      switch (type) {
        case "workAuditImg":
          this[type] = this[type].filter((item) => {
            return item.url != file.url;
          });
          break;
      }
    },
    /**
     * @descripttion: 图片改变
     * @Author: juanjuanhui
     * @Date: 2021-11-16 21:05:13
     * @param {*}
     * @return {*}
     */
    handleImgChange(file, type) {
      switch (type) {
        case "workAuditImg":
          if (this.workAuditImg.length > 0) {
            let { workAuditImg, ...data } = this.rules;
            this.rules = data;
            this.$refs.ruleForm.clearValidate("workAuditImg");
          } else {
            this.rules.workAuditImg = [
              { required: true, message: "请上传照片", trigger: "change" },
            ];
          }
          break;
      }
    },
    /**
     * @descripttion: 预览图片
     * @Author: juanjuanhui
     * @Date: 2021-07-08 21:55:27
     * @param {Object} file 视频文件信息
     */
    handlePreviewImg(file) {
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },
    /**
     * @descripttion: 图片超出限制
     * @Author: juanjuanhui
     * @Date: 2021-12-14 21:14:02
     * @param {*} files
     * @param {*} fileList
     */
    handleImgExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
  },
};
